export const qualityHighlights = [
  { icon: 'ri-microscope-line' },
  { icon: 'ri-route-line' },
  { icon: 'ri-shield-check-line' },
];

export const qualityLabs = [
  { img: 'https://readdy.ai/api/search-image?query=Close-up%20macro%20of%20premium%20white%20jasmine%20rice%20grains%20filling%20the%20frame%2C%20even%20soft%20daylight%2C%20bright%20clean%20cream%20background%2C%20high%20detail%20food%20texture%20photography&width=800&height=600&seq=lam-q-grain&orientation=landscape' },
  { img: 'https://storage.helloreaddy.io/project_files/35136070-61cb-45a9-b929-229bbdd5ade8/f9b7dcd7-83dd-4aba-890f-e17e10cfbfb2_compressed_kinh-lup.webp' },
  { img: 'https://readdy.ai/api/search-image?query=Neat%20rows%20of%20packaged%20rice%20sacks%20in%20a%20clean%20bright%20warehouse%20with%20soft%20daylight%2C%20pale%20neutral%20tones%2C%20industrial%20editorial%20photography&width=800&height=600&seq=lam-q-warehouse&orientation=landscape' },
];

export const qualityCertifications = [
  { icon: 'ri-award-line' },
  { icon: 'ri-shield-check-line' },
  { icon: 'ri-leaf-line' },
  { icon: 'ri-global-line' },
];